<template>
  <div id="init-home-container" class="mt-3 d-flex" style="width: 100%">
    <!--//@*/*
    //    *RPD CSIG  App v0.91
    //    * Copyright (c) 2024, Blue Cover Six LLC .John Molt All rights reserved.
    //    Code licensed under contract To Reno Police Department / City of Reno, in perpetuity
    //    */
    //-->

    <!-- <auth></auth> -->

    <v-spacer></v-spacer>
    <v-main>
      <v-container
        class="whitesmoke black--text"
        id="home-container"
        style="max-width: 768px"
      >
        <h4 class="whitesmoke black--text">
          Please complete the form and submit.
        </h4>
        <v-form ref="form" lazy-validation v-model="valid">
          <v-container>
            <v-row>
              <v-col cols="12" md="4">
                <v-text-field
                  v-model="cisg.submit_date"
                  label="Date:"
                  required
                  v-mask="'##/##/####'"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field
                  maxlength="120"
                  v-model="cisg.name"
                  label="Name (optional):"
                ></v-text-field>
              </v-col>

              <v-col cols="12" md="4">
                <v-text-field
                  maxlength="50"
                  v-model="cisg.division"
                  :rules="requiredRule"
                  label="Division most impacted:"
                  required
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="12">
                <label for="public_name"
                  >Do you wish to be identified when this suggestion is
                  published?</label
                >
                <v-select
                  label=""
                  id="public_name"
                  v-model="cisg.public_name"
                  :items="public_name_items"
                  attach
                  solo
                  :menu-props="{ bottom: true, offsetY: true }"
                ></v-select>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="12">
                <label>Primary Request/Suggestion (8000 char.):</label>
                <v-textarea
                  :rules="requiredRule"
                  maxlength="7999"
                  v-model="cisg.request"
                  name="request"
                  label=""
                  auto-grow
                  counter
                  outlined
                  dense
                ></v-textarea>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="12">
                <label>Suggested Solution (8000 char.):</label>
                <v-textarea
                  :rules="requiredRule"
                  aria-required
                  required
                  maxlength="7999"
                  v-model="cisg.solution"
                  name="solution"
                  label=""
                  auto-grow
                  counter
                  outlined
                  dense
                ></v-textarea>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="6">
                <label for="policy">Is there a policy in place?</label>
                <div style="visibility: hidden">row space</div>
                <v-select
                  id="policy"
                  v-model="cisg.policy"
                  :items="policy_items"
                  solo
                  attach
                  :menu-props="{ bottom: true, offsetY: true }"
                ></v-select>
              </v-col>
              <v-col cols="12" md="6">
                <label for="speak"
                  >Would you like to speak with someone regarding this
                  issue?</label
                >
                <v-select
                  id="speak"
                  v-model="cisg.speak"
                  :items="speak_items"
                  solo
                  attach
                  :menu-props="{ bottom: true, offsetY: true }"
                ></v-select>
              </v-col>
            </v-row>
            <v-row v-if="cisg.speak == 'Yes'">
              <v-col cols="12" md="12">
                <v-text-field
                  maxlength="120"
                  v-model="cisg.speak_name"
                  label="Who would you like to speak with?:"
                  placeholder="Enter Full Name"
                ></v-text-field>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" md="6">
                <label for="cost"
                  >Is there a financial cost to the solution?</label
                >
                <v-select
                  id="cost"
                  v-model="cisg.cost"
                  :items="cost_items"
                  solo
                  attach
                  :menu-props="{ bottom: true, offsetY: true }"
                ></v-select>
              </v-col>
              <v-col cols="12" md="6">
                <label for="funding"
                  >Has a funding stream been identified?</label
                >
                <v-select
                  id="funding"
                  v-model="cisg.funding"
                  :items="funding_items"
                  solo
                  attach
                  :menu-props="{ bottom: true, offsetY: true }"
                ></v-select>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="12">
                <label
                  >If funding stream yes, please discuss (8000 char.):</label
                >
                <v-textarea
                  maxlength="7999"
                  v-model="cisg.stream_discuss"
                  name="stream_discuss"
                  auto-grow
                  counter
                  outlined
                  dense
                ></v-textarea>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="12">
                <label>Other comments (8000 char.):</label>
                <v-textarea
                  maxlength="7999"
                  v-model="cisg.comments"
                  name="stream_discuss"
                  auto-grow
                  counter
                  outlined
                  dense
                ></v-textarea>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="4">
                <v-btn @click="save" class="black white--text">Submit</v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-form>
      </v-container>
    </v-main>
    <v-spacer></v-spacer>
  </div>
</template>

<style lang="scss" scoped>
@import "../scss/site.scss";

/* 0 media q */

@media (min-width: 0px) {
  #home-container {
    width: 100vw;
    max-width: 100vw;
    height: auto;
  }

  .results .v-expansion-panel-content::v-deep .v-expansion-panel-content__wrap,
  .recent .v-expansion-panel-content::v-deep .v-expansion-panel-content__wrap {
    padding: 0 7px !important;
  }

  .alice {
    color: aliceblue;
  }
}

/* 768 media q *
@media (min-width: 768px) {
}

/* 1025 media q */
@media (min-width: 1025px) {
}

/* 2048 media q */
@media (min-width: 2048px) {
}
</style>

<script>
/* eslint-disable */
import { bus_common } from "../mixins/bus_common";
// import auth from "./auth.vue";
//const add_edit = () => import("./add_edit.vue");

export default {
  name: "Home",
  components: {},
  mixins: [bus_common],
  data() {
    // Status, Fname, Lnprivateame, DOB, DIVISION
    return {
      user_props: {},
      policy_items: ["", "Yes", "No", "Do Not Know"],
      public_name_items: ["No", "Yes"],
      speak_items: ["", "Yes", "No"],
      cost_items: ["", "Yes", "No"],
      funding_items: ["", "Yes", "No"],
      //       new_cisg: {
      //         name: "John Molt test",
      //         division: "RPD IT",
      //         policy: "Yes",
      //         submit_date: "",
      //         speak: "Yes",
      //         request: `Lorem ipsum dolor sit amet consectetur adipisicing elit. Maxime mollitia,
      // molestiae quas vel sint commodi repudiandae consequuntur voluptatum laborum
      // numquam blanditiis harum quisquam eius sed odit fugiat iusto fuga praesentium
      // optio, eaque rerum! Provident similique accusantium nemo autem. Veritatis
      // obcaecati tenetur iure eius earum ut molestias architecto voluptate aliquam
      // nihil, eveniet aliquid culpa officia aut! Impedit sit sunt quaerat, odit,
      // tenetur error, harum nesciunt ipsum debitis quas aliquid. Reprehenderit,
      // quia. Quo neque error repudiandae fuga? Ipsa laudantium molestias eos
      // sapiente officiis modi at sunt excepturi expedita sint? Sed quibusdam
      // recusandae alias error harum maxime adipisci amet laborum.`,
      //         cost: "No",
      //         funding: "No",
      //         stream_discuss: `Lorem ipsum dolor sit amet consectetur adipisicing elit. Maxime mollitia,
      // molestiae quas vel sint commodi repudiandae consequuntur voluptatum laborum
      // numquam blanditiis harum quisquam eius sed odit fugiat iusto fuga praesentium
      // optio, eaque rerum! Provident similique accusantium nemo autem. Veritatis
      // obcaecati tenetur iure eius earum ut molestias architecto voluptate aliquam
      // nihil, eveniet aliquid culpa officia aut! Impedit sit sunt quaerat, odit,
      // tenetur error, harum nesciunt ipsum debitis quas aliquid. Reprehenderit,
      // quia. Quo neque error repudiandae fuga? Ipsa laudantium molestias eos
      // sapiente officiis modi at sunt excepturi expedita sint? Sed quibusdam
      // recusandae alias error harum maxime adipisci amet laborum.`,
      //         comments: `Lorem ipsum dolor sit amet consectetur adipisicing elit. Maxime mollitia,
      // molestiae quas vel sint commodi repudiandae consequuntur voluptatum laborum
      // numquam blanditiis harum quisquam eius sed odit fugiat iusto fuga praesentium
      // optio, eaque rerum! Provident similique accusantium nemo autem. Veritatis
      // obcaecati tenetur iure eius earum ut molestias architecto voluptate aliquam
      // nihil, eveniet aliquid culpa officia aut! Impedit sit sunt quaerat, odit,
      // tenetur error, harum nesciunt ipsum debitis quas aliquid. Reprehenderit,
      // quia. Quo neque error repudiandae fuga? Ipsa laudantium molestias eos
      // sapiente officiis modi at sunt excepturi expedita sint? Sed quibusdam
      // recusandae alias error harum maxime adipisci amet laborum.`,
      //       },
      new_cisg: {
        name: "",
        division: "",
        policy: "",
        submit_date: "",
        speak: "",
        request: "",
        cost: "",
        funding: "",
        stream_discuss: "",
        comments: "",
        speak_name: "",
        solution: "",
        public_name: "No",
      },
      cisg: {
        name: "",
        division: "",
        policy: "",
        submit_date: "",
        speak: "",
        request: "",
        cost: "",
        funding: "",
        stream_discuss: "",
        comments: "",
        speak_name: "",
        solution: "",
        public_name: "No",
      },
      valid: false,
      firstname: "",
      lastname: "",
      requiredRule: [(v) => !!v || "Required"],
      nameRules: [
        (v) => !!v || "Name is required",
        (v) => v.length <= 10 || "Name must be less than 10 characters",
      ],
      email: "",
      emailRules: [
        (v) => !!v || "E-mail is required",
        (v) => /.+@.+/.test(v) || "E-mail must be valid",
      ],
    };
  },
  watch: {
    "$store.state.user": function () {
      //keep this
      // if (this.$store.state.user.email != "") {
      //   let self = this;
      //   this.init();
      // }
    },
  },
  methods: {
    /* sendRequest(rowData) {
      console.log(rowData);
    }, */
    save() {
      if (!this.$refs.form.validate()) {
        this.swall_it(
          "Save Status",
          "Please attend to the Fields marked in red.",
          "warning",
          null,
          null
        );
        return true;
      }
      //save it

      let self = this;
      self.show_loader(true);
      let formIn = {};
      formIn.apiname = "save_csig";

      this.cisg.submit_date = this.format_date_sql(this.cisg.submit_date);
      formIn.cisg = this.cisg;

      this.$store
        .dispatch("anyapi", formIn)
        .then((data) => {
          self.show_loader(false);
          self.mrbreakpoint();
          self.swall_it(
            "Save Status",
            "Your submission has been recorded. For your records, please note your " +
              "reference number of 'CS" +
              data.csigId +
              "' . This will appear on the published outcomes.",
            "success",
            null,
            null
          );
          self.$refs.form.reset();
          self.cisg = this.mno(self.new_cisg);

          this.$nextTick(() => {
            console.log("do the date");
            self.cisg.submit_date = self.format_date_us(new Date());
          });

          //    self.cisg.submit_date = self.format_date_sql(new Date());
        })
        .catch((msg) => {
          this.show_loader(false);
          this.swall_it("Error", msg, "error", null, null);
        });
    },
    get_user_props() {
      //not doing this now.

      let self = this;
      self.show_loader(true);
      let formIn = {};
      formIn.apiname = "get_user_props";
      formIn.email = this.$store.state.user.email;
      formIn.token = this.$store.state.user.token;

      this.$store
        .dispatch("anyapi", formIn)
        .then((data) => {
          self.show_loader(false);
          //data contains the list of all new emps so refresh
          self.user_props = self.mno(data);
          self.new_cisg.name =
            self.user_props.fname + " " + self.user_props.lname;

          self.cisg = self.mno(self.new_cisg);
        })
        .catch((msg) => {
          this.show_loader(false);
          this.swall_it("Error", msg, "error", null, null);
        });
    },
    sendRequest() {
      alert("This button does nothing yet.");
    },
    message1() {
      alert("This button does nothing yet.");
    },

    init(self) {
      this.show_loader(false);
      this.new_cisg.submit_date = this.format_date_us(new Date());
      this.cisg = this.mno(this.new_cisg);
      this.swall_it(
        "Anonymous!",
        "You have successfully logged out of the RPD Portal. The RPD Comments/Suggestions app is an anonymous system. Cookies, and other identity information are NOT being recorded.",
        "success",
        null,
        null
      );
      // this.get_user_props();
    },
  },
  mounted() {
    var self = this;
    this.$nextTick(() => {
      if (this.$route.query.token != null) {
        self.$router.push("/");
        self.init();
      } else {
        self.init();
      }
    });
  },
};
</script>
